module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Compris',
        maxProdsTitle: 'Nombre maximal d’essentiels atteint',
        maxProdsDesc: 'Vous ne pouvez comparer que 3 essentiels à la fois. Retirez-en un et réessayez.'
    };

    return resources[label];
};
